import { Button, Pagination, Table } from 'antd';
import React, { useState } from 'react';
import Typograpy from '../../../components/Typograpy';
import { useHideModal, useShowAlert, useShowModal } from '../../../hooks';
import { Container } from './style';
import { useEffect } from 'react';
import FullScreen from '../../../components/Spinner/FullScreen';
import message from 'services/message';
import Filters from 'components/Filters';
import { buttons } from './helper';
import { IoArchiveOutline } from 'react-icons/io5';
import Confirm from 'components/Confirm';
import { useDispatch } from 'react-redux';
import { setModalLoading } from 'redux/modules/modals/actions';

export default () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();

  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [active, setActive] = useState(true);
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const dispatch = useDispatch();

  const handleActive = (item) => {
    setActive(item.value);
  };

  const fetchMessageData = async () => {
    setLoading(true);
    let queryData = { limit: size, page: page, active: active };

    try {
      const resData = await message.getAll(queryData);
      const finallyData = resData?.docs?.map((itm, index) => ({
        ...itm,
        key: page * size - size + index + 1,
      }));
      setData(finallyData);
      setTotal(resData.totalDocs);
    } catch (err) {
      console.log(err);
      error('Хатолик юз берди');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessageData();
  }, [page, size, active]);

  const columns = [
    {
      title: '№',
      dataIndex: 'key',
      key: 'key',
      width: '5%',
      align: 'center',
    },
    {
      title: 'Фамилия',
      dataIndex: 'last_name',
      key: 'last_name',
      width: '18%',
    },
    {
      title: 'Исм',
      dataIndex: 'first_name',
      key: 'first_name',
      width: '18%',
    },
    {
      title: 'Телефон рақами',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
      width: '10%',
    },
    {
      title: 'Хабар',
      dataIndex: 'message',
      key: 'message',
    },
    {
      width: '15%',
      align: 'center',
      title: 'Архивлаш',
      dataIndex: '',
      key: 'x',
      render: (props) => (
        <Button
          className='archive-btn'
          onClick={() => handleArchiveModal(props?._id)}
        >
          <IoArchiveOutline size={20} />
        </Button>
      ),
    },
  ];

  const handleArchiveModal = (messageId) => {
    showBlured({
      title: 'Архивлаш',
      maxWidth: '400px',
      height: '300px',
      withHeader: false,
      body: () => (
        <Confirm
          agree={() => handleArchive(messageId)}
          cancel={hideModal}
          title='Архивлашни тасдиқлайсизми ?'
        />
      ),
    });
  };

  const handleArchive = (messageId) => {
    dispatch(setModalLoading(true));
    message
      .update(messageId, { active: false })
      .then(() => {
        hideModal();
        fetchMessageData();
      })
      .catch((err) => {
        console.log(err);
        error('Хатолик юз берди', 2, 'bottom');
      })
      .finally(() => dispatch(setModalLoading(false)));
  };

  const onChange = (page) => {
    setPage(page);
  };

  const onShowSizeChange = (current, pageSize) => {
    setPage(1);
    setSize(pageSize);
  };

  if (loading) return <FullScreen />;
  return (
    <Container>
      <Typograpy>Сайтдан келган хабарлар</Typograpy>
      <Filters
        list={buttons}
        active={active}
        handleActive={handleActive}
      />

      <Table
        bordered
        columns={active ? columns : columns?.slice(0, -1)}
        dataSource={data}
        pagination={false}
      />
      {total / size > 1 && (
        <div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
          <Pagination
            total={total}
            current={page}
            defaultPageSize={size}
            showSizeChanger
            onChange={onChange}
            onShowSizeChange={onShowSizeChange}
          />
        </div>
      )}
    </Container>
  );
};
